
import "./login.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

import { useForm } from "react-hook-form";

import { auth } from "../../services/firebaseConnection";
import { signInWithEmailAndPassword } from "firebase/auth";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, where, query, limit, orderBy } from "firebase/firestore";

/* navegação */
import { Link, useNavigate } from "react-router-dom";

/* redux */
import { useDispatch } from "react-redux";
import { createUser } from "../../redux/user/slice";
import { createAgent } from "../../redux/agent/slice";

/* funções auxiliares */
import { registerLog, checkExists, showError, clearError } from "../../services/functions/functions.ts";



export default function Login() {

    const [error, setError] = useState("0");

    const { handleSubmit, register, getValues } = useForm();

    /* refs para tratamento de erros */
    const refEmail = useRef(null);
    const refLabelEmail = useRef(null);
    const refErrorEmail = useRef(null);

    const refSenha = useRef(null);
    const refLabelSenha = useRef(null);
    const refErrorSenha = useRef(null);
    /* -- */

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [isPending, startTransition] = useTransition();

    useEffect(() => { window.scrollTo(0, 0); }, []);


    async function login(data) {
        
        const v_email = (vemail) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(vemail); }
       
        let em = refEmail.current?.value || "";
        if(!v_email(em)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        let sn = refSenha.current?.value || "";
        if(sn.length < 6) {
            showError(refSenha, refLabelSenha, refErrorSenha, "A senha deve ter entre 6 a 12 caracteres", setError, "senha");
            return;
        }

        startTransition( async() => {

        try {

            //verifica email existente
            let ckma = await checkExists("clients", "email", em);
            if(ckma === 0) {
                showError(refEmail, refLabelEmail, refErrorEmail, "Esse email não consta em nosso cadastro", setError, "email");
                return;
            }

            //faz a autenticação
            await signInWithEmailAndPassword(auth, em, sn)
            .then( async (value) => {
                
                let u_em, u_nm, u_ml, a_id, a_nm, a_pl, a_st;

                let uid = value.user.uid;
                
                const clientsdb = collection(db, "clients");
                const clientsquery = query(clientsdb, where("id", "==", uid));

                await getDocs(clientsquery)
                .then((value) => {
                    u_em = value.docs[0].data().empresa;
                    u_nm = value.docs[0].data().responsavel;
                    u_ml = value.docs[0].data().email;
                })

                sessionStorage.setItem('id', JSON.stringify(uid));
                sessionStorage.setItem('empresa', JSON.stringify(u_em));
                sessionStorage.setItem('nome', JSON.stringify(u_nm));
                sessionStorage.setItem('email', JSON.stringify(u_ml));

                dispatch(createUser({
                    id: uid,
                    empresa: u_em,
                    nome: u_nm,
                    email: u_ml,
                }))

                a_id = "0";
                a_nm = "";
                a_pl = "";
                a_st = 0;
                
                const agentsdb = collection(db, "agents");
                const agentsquery = query(agentsdb, where("id_client", "==", uid), orderBy("data_criacao", "desc"), limit(1));

                await getDocs(agentsquery)
                .then((value) => {
                    if(value.size === 1) {                    
                        a_id = value.docs[0].id;
                        a_nm = value.docs[0].data().nome;
                        a_pl = value.docs[0].data().plano;
                        a_st = value.docs[0].data().status;
                    }
                })

                sessionStorage.setItem('agente_id', JSON.stringify(a_id));
                sessionStorage.setItem('agente', JSON.stringify(a_nm));
                sessionStorage.setItem('plano', JSON.stringify(a_pl));
                sessionStorage.setItem('status', JSON.stringify(a_st));

                dispatch(createAgent({
                    id: a_id,
                    nome: a_nm,
                    plano: a_pl,
                    status: a_st,
                }))

                registerLog(uid, "/login/success");

                navigate("/panel");
            
            })
            .catch((erro) => {

                let er;

                if(erro.code === "auth/invalid-credential") {
                    er = "A senha não está correta para esse email.";
                } else {
                    er = erro;
                }

                registerLog(-1, "/login/fail=" + em);

                showError(refSenha, refLabelSenha, refErrorSenha, er, setError, "senha");

            })

        }
        catch(erro) {
            alert(erro);
        }
        })

    }



    return(

        <div className="context">

            <Header access={0}></Header>

            <div className="content">
                <div className="ft_topico">Acesso a nossa plataforma</div>
                <div className="ft_descricao">Ao acessar a plataforma você poderá configurar todos os parâmetros do seu agente.<br />Personalize ele conforme suas preferências e terá seu maior aliado para auxiliá-lo no atendimento a seus clientes.</div>
                <div className="space"></div>
                <span className="login_texto_destaque">Ainda não tem cadastro?</span>
                <div className="ft_descricao">Faça seu cadastro com pouquíssimas informações</div>
                <div className="login_space"></div>
                <Link to="/register" className="login_register" style={{textAlign: "center"}}>QUERO ME CADASTRAR</Link>
                <div className="space"></div>
                <div className="ft_descricao">Já é cadastrado?<br />faça seu login abaixo:</div>
                <div className="login_space"></div>

                <div className="border_form login_border_form">
                    <form className="form" onSubmit={handleSubmit(login)}>
                        <span className="title_form">Login na plataforma</span>
                        <span className="subtitle_form">Entre com seu email e a senha.</span>
                        
                        <span ref={refErrorEmail} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelEmail}>
                        <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSubmit(login)();}}}></input>
                        <span className="label">Seu Email</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span ref={refErrorSenha} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelSenha}>
                        <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refSenha.current = el; register("senha").ref(el);}} onClick={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onChange={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSubmit(login)();}}}></input>
                        <span className="label">Sua Senha</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <button type="submit" name="bt1" className={ isPending ? "button_disabled_form" : "button_form" } disabled={ isPending ? true : false }>{ isPending ? "AGUARDE ..." : "ACESSAR" }</button>
                    </form>
                </div>

                <div className="space"></div>
                <span>Esqueceu a senha? Clique Aqui</span>
                <div className="space"></div>

            </div>

            <Footer access={0}></Footer>

        </div>

    )
}